import { createIcon } from '@consta/icons/Icon'
import type { FC, SVGProps } from 'react'

const IconCrossCorrelationS: FC<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14.1871 0.81281C14.48 1.1057 14.48 1.58058 14.1871 1.87347L2.87336 13.1872C2.58047 13.4801 2.10559 13.4801 1.8127 13.1872C1.51981 12.8943 1.51981 12.4194 1.8127 12.1265L13.1264 0.81281C13.4193 0.519916 13.8942 0.519916 14.1871 0.81281Z" />
    <path d="M2.99995 7.60001C2.99995 8.37321 2.37315 9.00001 1.59995 9.00001C0.826753 9.00001 0.199951 8.37321 0.199951 7.60001C0.199951 6.82681 0.826753 6.20001 1.59995 6.20001C2.37315 6.20001 2.99995 6.82681 2.99995 7.60001Z" />
    <path d="M5.99995 3.60001C5.99995 4.37321 5.37315 5.00001 4.59995 5.00001C3.82675 5.00001 3.19995 4.37321 3.19995 3.60001C3.19995 2.82681 3.82675 2.20001 4.59995 2.20001C5.37315 2.20001 5.99995 2.82681 5.99995 3.60001Z" />
    <path d="M15 7.60001C15 8.37321 14.3731 9.00001 13.6 9.00001C12.8268 9.00001 12.2 8.37321 12.2 7.60001C12.2 6.82681 12.8268 6.20001 13.6 6.20001C14.3731 6.20001 15 6.82681 15 7.60001Z" />
  </svg>
)

export const IconCrossCorrelation = createIcon({
  name: 'IconCrossCorrelation',
  l: IconCrossCorrelationS,
  m: IconCrossCorrelationS,
  s: IconCrossCorrelationS,
  xs: IconCrossCorrelationS,
})
